export const PRODUCT_TYPE = {
    CONTACTS: 'Contacts',
    EYEGLASSES: 'Prescription eyeglasses',
    SUNGLASSES: 'Prescription sunglasses',
    SUNGLASSES_PLANO: 'Plano sunglasses',
    ACCESSORIES: 'Accessories',
    READERS: 'Readers',
};
